module.exports = __webpack_public_path__ + "img/wugeshoujmaiji2.307cc5fb.png";